import { Injectable, inject } from '@angular/core';
import { HeaderService } from 'onego-header';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';

import { ControlRoute } from '../../models/control-route.model';

@Injectable({ providedIn: 'root' })
export class ControlBarService {
    // Control Routing
    private readonly _routeStack: BehaviorSubject<Array<ControlRoute>> = new BehaviorSubject([]);

    private readonly _menuOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private readonly _shown: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    public readonly controlRoute: Observable<ControlRoute> = this._routeStack
        .asObservable()
        .pipe(map((stack) => stack[stack.length - 1]));

    public readonly lastControlRoute: Observable<ControlRoute> = this._routeStack
        .asObservable()
        .pipe(map((stack) => (stack.length >= 2 ? stack[stack.length - 2] : null)));

    public readonly menuOpen: Observable<boolean> = this._menuOpen.asObservable();
    public readonly shown: Observable<boolean> = this._shown.asObservable();

    private readonly headerService = inject(HeaderService);

    public constructor() {
        this.headerService.loggedIn
            .pipe(
                filter((loggedIn) => loggedIn),
                tap(() => {
                    this._menuOpen.next(false);
                })
            )
            .subscribe();
    }

    public pushRoute(route: ControlRoute): void {
        if (!route.name) route.name = this.getNameForRoute(route);
        this._routeStack.next([...this._routeStack.value, route]);
    }

    public popRoute(routes = 1): void {
        const routeStack = this._routeStack.value;
        for (let i = 0; i < routes && routeStack.length > 1; i++) {
            routeStack.pop();
        }
        this._routeStack.next(routeStack);
    }

    public replaceRoute(route: ControlRoute, replaceAll = false): void {
        if (!route.name) route.name = this.getNameForRoute(route);
        const routeStack = replaceAll ? [] : this._routeStack.value || [];
        if (routeStack.length >= 1) {
            routeStack.splice(this._routeStack.value.length - 1, 1, route);
        } else {
            routeStack.push(route);
        }
        this._routeStack.next(routeStack);
    }

    public show(value: boolean): void {
        setTimeout(() => this._shown.next(value), 0);
    }

    public toggle(): void {
        setTimeout(() => this._shown.next(!this._shown.value), 0);
    }

    public showMenu(value: boolean): void {
        setTimeout(() => this._menuOpen.next(value), 0);
    }

    public toggleMenu(): void {
        setTimeout(() => this._menuOpen.next(!this._menuOpen.value), 0);
    }

    private getNameForRoute(route: ControlRoute): string {
        switch (route.mode) {
            case 'LIST':
                return 'mapView.list.title';
            case 'REPORT':
                return 'mapView.report-wizard.title';
            case 'DETAIL':
                return `mapView.detail.title.${route.entityType}`;
        }
    }
}
